import { Dialog, DialogProps } from "@blueprintjs/core"
import { Button } from "@zeguro/component-library"

import { ErrorContainer } from "./Common"

interface IZegDialog extends DialogProps {
  onClose: () => void
  onCancel?: () => void
  onAction?: () => void
  closeText?: string
  actionText?: string
  text?: string | JSX.Element
  body?: JSX.Element
  content?: JSX.Element
  error?: string | JSX.Element
  showOnlyPrimaryButton?: boolean
  closeButtonId?: string
  actionButtonId?: string
  actionButtonWidth?: number
}

const ZegDialog = (props: IZegDialog) => {
  const {
    isOpen,
    onClose,
    onCancel,
    onAction,
    closeText,
    actionText,
    text,
    title,
    body,
    content,
    error,
    className,
    children,
    showOnlyPrimaryButton,
    closeButtonId,
    actionButtonId,
    actionButtonWidth,
    ...rest
  } = props

  const standardBody = (
    <div>
      <div className="bp5-dialog-body">
        <div>{text}</div>
        {error ? <ErrorContainer> {error} </ErrorContainer> : null}
      </div>
    </div>
  )

  const footer = (
    <div className="bp5-dialog-footer" style={{ textAlign: "right" }}>
      {showOnlyPrimaryButton ? null : (
        <Button
          variant="tertiary"
          onClick={onCancel || onClose}
          width={"100px"}
          id={closeButtonId || ""}
        >
          {closeText || "Cancel"}
        </Button>
      )}
      &nbsp;
      <Button
        variant="primary"
        hidden={!onAction}
        onClick={onAction}
        width={actionButtonWidth ? `${actionButtonWidth}px` : "100px"}
        id={actionButtonId || ""}
      >
        {actionText || "Confirm"}
      </Button>
    </div>
  )

  const customBody = body ? <div className="bp5-dialog-body">{body}</div> : null

  return (
    <Dialog
      className={`${className} zeg-dialog__close-button`}
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      {...rest}
    >
      {content || children || customBody || standardBody}
      {content || children ? "" : footer}
    </Dialog>
  )
}

export default ZegDialog
